module.exports = __webpack_public_path__ + "img/147-b29a30.png";